<template>
  <div class="col-lg-4 mb-4 d-flex align-items-stretch">
    <div class="card">
      <router-link :to="deviceDetail" class="card-link">
        <div class="card-img-top" :class="background"></div>
        <div class="card-body">
          <div class="card-icons">
            <img :src="iconFill" class="card-icon" :alt="cartridgeFill" />
            <MaterialSvg
              v-if="error === true"
              class="card-icon icon-red"
              name="cancel"
              :width="24"
            />
            <MaterialSvg
              v-else-if="
                error === false && online === true && connectionType === 'wifi'
              "
              class="icon-white card-icon"
              name="wifi"
              :width="24"
            />
            <MaterialSvg
              v-else-if="
                error === false && online === false && connectionType === 'wifi'
              "
              class="icon-red card-icon"
              name="wifi_off"
              :width="24"
            />
            <MaterialSvg
              v-else-if="
                error === false && online === true && connectionType === 'gprs'
              "
              class="icon-white card-icon"
              name="gprs"
              :width="32"
            />
            <MaterialSvg
              v-else-if="
                error === false && online === false && connectionType === 'gprs'
              "
              class="icon-red card-icon"
              name="gprs_offline"
              :width="32"
            />
          </div>
          <h6 class="card-subtitle mb-2 mt-3 text-muted">
            {{ this.organisation }}
          </h6>
          <h6 class="card-subtitle mb-3 text-muted">
            {{ $t('common.hub') }} {{ this.$vnode.key }}
          </h6>
          <h5 class="card-title mb-0">{{ this.title }}</h5>
          <p class="card-text mb-5">{{ this.scent }}</p>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Hub',
  props: {
    title: {
      type: String,
      default: 'title',
    },
    scent: {
      type: String,
      default: 'scent',
    },
    background: {
      type: String,
      default: 'neutraal',
    },
    hash: {
      type: String,
      required: true,
    },
    error: {
      type: Boolean,
    },
    online: {
      type: Boolean,
    },
    connectionType: {
      type: String,
    },
    cartridgeFill: {
      type: String,
    },
    cartridgeSize: {
      type: Number,
      default: 400,
    },
    organisation: {
      type: String,
    },
  },
  computed: {
    deviceDetail() {
      return 'device/' + this.hash;
    },
    cartridgeType() {
      return this.cartridgeSize < 1000 ? 'cartridge' : 'jerrycan';
    },
    iconFill() {
      return (
        '/images/icons/' +
        this.cartridgeType +
        '_' +
        this.cartridgeFill +
        '.svg'
      );
    },
  },
};
</script>
